module.exports = __webpack_public_path__ + "assets/img/4505d4f20088d6338c77ea8b8fb4901f.png";